import { z } from 'zod';
import { photoSchema, originalSizeSchema, InstitutionType } from '@do/models';

const baseSchema$1 = z.object({
    id: z.number({ required_error: 'id is required in art asset' }),
    name_english: z.string({ required_error: 'name_english is required in art asset' }),
    creation_year: z.string({ required_error: 'creating_years is required in art asset' }),
});
const readyForSaleSchema = baseSchema$1.merge(z.object({
    main_photo: z.string({ required_error: 'main_photo is required in art asset' }).uuid(),
    artists: z.array(z.number()).min(1, { message: 'artists are required in art asset' }),
    institutions: z.array(z.number()).min(1, { message: 'institutions are required in art asset' }),
    medium: z.array(z.number()).min(1, { message: 'art_medium is required in art asset' }),
    styles: z.array(z.number()).min(1, { message: 'art_styles is required in art asset' }),
    digital_common: z.object({
        file: z.string({ required_error: 'digital_common file is required in art asset' }).uuid(),
        preview: z.string({ required_error: 'digital_common preview is required in art asset' }).uuid(),
    }),
}));
const readyForSaleSchemaWithRelations = baseSchema$1.merge(z.object({
    main_photo: photoSchema,
    artists: z.array(z.object({})).min(1, { message: 'artists are required in art asset' }),
    institutions: z.array(z.object({})).min(1, { message: 'institutions are required in art asset' }),
    medium: z.array(z.object({})).min(1, { message: 'art_medium is required in art asset' }),
    styles: z.array(z.object({})).min(1, { message: 'art_styles is required in art asset' }),
}));

const baseSchema = z.object({
    id: z.number({ required_error: 'id is required in art asset' }),
    name_english: z.string({ required_error: 'name_english is required in art asset' }),
    creation_year: z.string({ required_error: 'creating_years is required in art asset' }),
});
const verifiableSchema = baseSchema
    .extend({
    main_photo: z.string({ required_error: 'main_photo is required in art asset' }).uuid(),
    artists: z.array(z.number()).min(1, { message: 'artists are required in art asset' }),
    institutions: z.array(z.number()).min(1, { message: 'institutions are required in art asset' }),
    medium: z.array(z.number()).min(1, { message: 'art_medium is required in art asset' }),
    styles: z.array(z.number()).min(1, { message: 'art_styles is required in art asset' }),
})
    .merge(originalSizeSchema);
const verifiableSchemaWithRelations = baseSchema
    .extend({
    main_photo: photoSchema,
    artists: z.array(z.object({})).min(1, { message: 'artists are required in art asset' }),
    institutions: z.array(z.object({})).min(1, { message: 'institutions are required in art asset' }),
    medium: z.array(z.object({})).min(1, { message: 'art_medium is required in art asset' }),
    styles: z.array(z.object({})).min(1, { message: 'art_styles is required in art asset' }),
})
    .merge(originalSizeSchema);

var index$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    readyForSaleSchema: readyForSaleSchema,
    readyForSaleSchemaWithRelations: readyForSaleSchemaWithRelations,
    verifiableSchema: verifiableSchema,
    verifiableSchemaWithRelations: verifiableSchemaWithRelations
});

var index$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    validation: index$3
});

function isArtistLike(type) {
    return type === InstitutionType.Artist || type === InstitutionType.Photographer;
}

var index$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    isArtistLike: isArtistLike
});

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    rules: index$1
});

export { index$2 as ArtAssetDomain, index as InstitutionDomain };
